/**
 * Pear — React entry point.
 *
 * Wave R2: React takes over rendering entirely. The vanilla shell (main.ts)
 * and the hand-authored markup in index.html are retired; App renders the
 * header, pair screen, tab bar and thread from state instead of toggling
 * `hidden` attributes by hand.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  console.error('[Pear] #root missing — React could not mount');
}
